import { render, staticRenderFns } from "./FollowUpList.vue?vue&type=template&id=3e481bbe&scoped=true&"
import script from "./FollowUpList.vue?vue&type=script&lang=js&"
export * from "./FollowUpList.vue?vue&type=script&lang=js&"
import style0 from "./FollowUpList.vue?vue&type=style&index=0&id=3e481bbe&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e481bbe",
  null
  
)

export default component.exports